import { InternalLink as Link } from "components";
import {ROUTES} from 'routes';

export const ContactUs = ({ text = "Contact us", lower = false }) => (
  <Link to={ROUTES.contact}>{lower ? text.toLowerCase() : text}</Link>
);
